// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_eq-j";
export var fulfillmentFormRail = "_eq-i";
export var headerTitleRow = "_eq-l";
export var orderDetailsWrapper = "_eq-g";
export var orderLinkTrigger = "_eq-2";
export var paymentInformationGrid = "_eq-q";
export var paymentSummaryColumn = "_eq-r";
export var phoneShipmentPickerButton = "_eq-e";
export var phoneShipmentPickerButtonContent = "_eq-f";
export var phoneShipmentPickerButtonWrapper = "_eq-d";
export var phoneShipmentPickerTrigger = "_eq-c";
export var shipmentContainer = "_eq-k";
export var shipmentDetailsMainPane = "_eq-h";
export var shipmentNavigationCard = "_eq-a";
export var shipmentNavigationEdgeTrigger = "_eq-6";
export var shipmentNavigationRail = "_eq-3";
export var shipmentNavigationRailEnter = "_eq-5";
export var shipmentNavigationRailHeader = "_eq-9";
export var shipmentNavigationRailOverlay = "_eq-4";
export var shipmentNavigationScrim = "_eq-7";
export var shipmentSummaryFact = "_eq-n";
export var shipmentSummaryGrid = "_eq-m";
export var shipmentSummaryMetadataRow = "_eq-o";
export var shipmentSummaryTags = "_eq-p";
export var shipmentWorkspace = "_eq-0";
export var shipmentWorkspaceBodyTablet = "_eq-8";
export var shipmentWorkspaceContent = "_eq-b";
export var shipmentWorkspaceHeader = "_eq-1";